import { createSlice } from "@reduxjs/toolkit";
import { withValuePayload, emptyPayload } from "libs/actionHelpers";

const initialState = {
  cuiTitular: null,
  nombreAgencia: null,
  nombreTitular: null,
  provinciaAgencia: null,
  localidadAgencia: null,
  codigoPostalAgencia: null,
  direccionAgencia: null,
  tipoAgencia: null,
  tipoVehiculo: null,
  nombreContacto: null,
  telefonoContacto: null,
  terminosYCondiciones: null,
  isForward: true,
  isLoading: false,
};

const setForwardValue = (key) => ({
  prepare: withValuePayload,
  reducer: (state, action) => {
    state[key] = action.payload.value;
    state.isForward = true;
  },
});

const clearBackwardField = (key) => ({
  prepare: emptyPayload,
  reducer: (state) => {
    state[key] = null;
    state.isForward = false;
  },
});

const signupAgenciaSlice = createSlice({
  name: "authentication/signupAgencia",
  initialState,
  reducers: {
    clear: {
      prepare: emptyPayload,
      reducer: () => ({ ...initialState, isForward: true }),
    },
    setCuiTitular: setForwardValue("cuiTitular"),
    clearCuiTitular: clearBackwardField("cuiTitular"),
    setNombreAgencia: setForwardValue("nombreAgencia"),
    clearNombreAgencia: clearBackwardField("nombreAgencia"),
    setNombreTitular: setForwardValue("nombreTitular"),
    clearNombreTitular: clearBackwardField("nombreTitular"),
    setProvinciaAgencia: {
      prepare: withValuePayload,
      reducer: (state, action) => {
        state.provinciaAgencia = action.payload.value;
        state.localidadAgencia =
          action.payload.value === 1 ? "CIUDAD AUTONOMA DE BS. AS." : null;
        state.isForward = true;
      },
    },
    clearProvinciaAgencia: clearBackwardField("provinciaAgencia"),
    setLocalidadAgencia: setForwardValue("localidadAgencia"),
    clearLocalidadAgencia: clearBackwardField("localidadAgencia"),
    setCodigoPostalAgencia: setForwardValue("codigoPostalAgencia"),
    clearCodigoPostalAgencia: clearBackwardField("codigoPostalAgencia"),
    setDireccionAgencia: setForwardValue("direccionAgencia"),
    clearDireccionAgencia: clearBackwardField("direccionAgencia"),
    setTipoAgencia: setForwardValue("tipoAgencia"),
    clearTipoAgencia: clearBackwardField("tipoAgencia"),
    setTipoVehiculo: setForwardValue("tipoVehiculo"),
    clearTipoVehiculo: clearBackwardField("tipoVehiculo"),
    setNombreContacto: setForwardValue("nombreContacto"),
    clearNombreContacto: clearBackwardField("nombreContacto"),
    setTelefonoContacto: setForwardValue("telefonoContacto"),
    clearTelefonoContacto: clearBackwardField("telefonoContacto"),
    setTerminosYCondiciones: {
      prepare: emptyPayload,
      reducer: (state) => {
        state.terminosYCondiciones = true;
        state.isForward = true;
      },
    },
    clearTerminosYCondiciones: {
      prepare: emptyPayload,
      reducer: (state) => {
        state.terminosYCondiciones = false;
        state.isForward = false;
      },
    },
    submitSignupAgenciaInited: {
      prepare: (props) => ({ payload: { props } }),
      reducer: () => undefined,
    },
    submitSignupAgenciaCompleted: {
      prepare: emptyPayload,
      reducer: () => undefined,
    },
    submitSignupAgenciaFailed: {
      prepare: (error) => ({ payload: { error } }),
      reducer: () => undefined,
    },
  },
});

const {
  clear,
  setCuiTitular,
  clearCuiTitular,
  setNombreAgencia,
  clearNombreAgencia,
  setNombreTitular,
  clearNombreTitular,
  setProvinciaAgencia,
  clearProvinciaAgencia,
  setLocalidadAgencia,
  clearLocalidadAgencia,
  setCodigoPostalAgencia,
  clearCodigoPostalAgencia,
  setDireccionAgencia,
  clearDireccionAgencia,
  setTipoAgencia,
  clearTipoAgencia,
  setTipoVehiculo,
  clearTipoVehiculo,
  setNombreContacto,
  clearNombreContacto,
  setTelefonoContacto,
  clearTelefonoContacto,
  setTerminosYCondiciones,
  clearTerminosYCondiciones,
  submitSignupAgenciaInited,
  submitSignupAgenciaCompleted,
  submitSignupAgenciaFailed,
} = signupAgenciaSlice.actions;

const submitSignupAgencia = (data) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(submitSignupAgenciaInited({ data }));
      await services.api.postSignupAgencia(data);
      dispatch(submitSignupAgenciaCompleted());
    } catch (error) {
      console.error(error);
      dispatch(submitSignupAgenciaFailed(error));
    }
  };
};

export default signupAgenciaSlice.reducer;
export {
  clear,
  setCuiTitular,
  clearCuiTitular,
  setNombreAgencia,
  clearNombreAgencia,
  setNombreTitular,
  clearNombreTitular,
  setProvinciaAgencia,
  clearProvinciaAgencia,
  setLocalidadAgencia,
  clearLocalidadAgencia,
  setCodigoPostalAgencia,
  clearCodigoPostalAgencia,
  setDireccionAgencia,
  clearDireccionAgencia,
  setTipoAgencia,
  clearTipoAgencia,
  setTipoVehiculo,
  clearTipoVehiculo,
  setNombreContacto,
  clearNombreContacto,
  setTelefonoContacto,
  clearTelefonoContacto,
  setTerminosYCondiciones,
  clearTerminosYCondiciones,
  submitSignupAgencia,
};
